export const storeManageListNewData = [
  {
    id: 'baseInfo',
    title: '',
    data: [
      // {
      //   id: 'times',
      //   name: '1.召开理事会次数',
      //   placeholder: '',
      //   type: 'input',
      //   checkType: 'required',
      //   newDisabled: true,
      //   newShow: true,
      //   ifEdit:false,
      //   value: '55555555',
      //   options: [],
      //   expand: {},
      //   hasupload:''
      // },
      // {
      //   id: 'yunxing',
      //   name: '2.简介理事会及其他形式决策机构运行情况：（包括组成人员情况、履职情况、相关决议、建议采纳情况等）',
      //   placeholder: '',
      //   type: 'textarea',
      //   checkType: 'required',
      //   newDisabled: false,
      //   newShow: true,
      //   ifEdit:true,
      //   value: '',
      //   options: [],
      //   expand: {
      //     autosize: {minRows: 4, maxRows: 10}
      //   },
      //   hasupload:'yunxingupload'
      // },
      // {
      //   id: 'yunxingupload',
      //   name: '',
      //   placeholder: '',
      //   type: 'img',
      //   checkType: 'required',
      //   newDisabled: false,
      //   newShow: true,
      //   ifEdit:true,
      //   value: [],
      //   options: [],
      //   filetype:'',
      //   expand: {
      //     limit: 1
      //   },
      //   hasupload:''
      // },
      // {
      //   id: 'description',
      //   name: '3.简介监事会或其他形式决策机构组建、运行情况',
      //   placeholder: '',
      //   type: 'textarea',
      //   checkType: 'required',
      //   newDisabled: false,
      //   newShow: true,
      //   ifEdit:false,
      //   value: '',
      //   options: [],
      //   expand: {
      //     autosize: {minRows: 4, maxRows: 10}
      //   },
      //   hasupload:''
      // },
    ]
  }
];
